import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateWsapiImportMutationVariables = Types.Exact<{
  input: Types.CreateWsapiImportInput;
}>;


export type CreateWsapiImportMutation = { __typename?: 'Mutation', createWsapiImport: { __typename?: 'WsapiImportPayload', wsapiImport?: { __typename?: 'WsapiImportStateData', wsapiImportId: string, integrationId: string, tenantId: string, enabled: boolean, runNow: boolean, scheduleDayOfWeek?: number | null, scheduleTimeOfDay?: string | null, created: Types.TDateISO, createdBy: string, updated: Types.TDateISO, updatedBy: string, entityMappings: Array<{ __typename?: 'EntityMappingData', entityMappingId: string, entityType: Types.WsapiImportEntityType, sourceTable: string, keySourceField: string, keyTargetField: string, enabled: boolean, fieldMappings: Array<{ __typename?: 'FieldMappingData', sourceField: string, targetField: string, sanitize: boolean, kind: Types.FieldMappingKind }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddWsapiImportEntityMappingMutationVariables = Types.Exact<{
  input: Types.AddWsapiImportEntityMappingInput;
}>;


export type AddWsapiImportEntityMappingMutation = { __typename?: 'Mutation', addWsapiImportEntityMapping: { __typename?: 'WsapiImportPayload', wsapiImport?: { __typename?: 'WsapiImportStateData', wsapiImportId: string, integrationId: string, tenantId: string, enabled: boolean, runNow: boolean, scheduleDayOfWeek?: number | null, scheduleTimeOfDay?: string | null, created: Types.TDateISO, createdBy: string, updated: Types.TDateISO, updatedBy: string, entityMappings: Array<{ __typename?: 'EntityMappingData', entityMappingId: string, entityType: Types.WsapiImportEntityType, sourceTable: string, keySourceField: string, keyTargetField: string, enabled: boolean, fieldMappings: Array<{ __typename?: 'FieldMappingData', sourceField: string, targetField: string, sanitize: boolean, kind: Types.FieldMappingKind }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetWsapiImportRunNowMutationVariables = Types.Exact<{
  input: Types.SetWsapiImportRunNowInput;
}>;


export type SetWsapiImportRunNowMutation = { __typename?: 'Mutation', setWsapiImportRunNow: { __typename?: 'WsapiImportPayload', wsapiImport?: { __typename?: 'WsapiImportStateData', wsapiImportId: string, integrationId: string, tenantId: string, enabled: boolean, runNow: boolean, scheduleDayOfWeek?: number | null, scheduleTimeOfDay?: string | null, created: Types.TDateISO, createdBy: string, updated: Types.TDateISO, updatedBy: string, entityMappings: Array<{ __typename?: 'EntityMappingData', entityMappingId: string, entityType: Types.WsapiImportEntityType, sourceTable: string, keySourceField: string, keyTargetField: string, enabled: boolean, fieldMappings: Array<{ __typename?: 'FieldMappingData', sourceField: string, targetField: string, sanitize: boolean, kind: Types.FieldMappingKind }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateWsapiImportScheduleMutationVariables = Types.Exact<{
  input: Types.UpdateWsapiImportScheduleInput;
}>;


export type UpdateWsapiImportScheduleMutation = { __typename?: 'Mutation', updateWsapiImportSchedule: { __typename?: 'WsapiImportPayload', wsapiImport?: { __typename?: 'WsapiImportStateData', wsapiImportId: string, integrationId: string, tenantId: string, enabled: boolean, runNow: boolean, scheduleDayOfWeek?: number | null, scheduleTimeOfDay?: string | null, created: Types.TDateISO, createdBy: string, updated: Types.TDateISO, updatedBy: string, entityMappings: Array<{ __typename?: 'EntityMappingData', entityMappingId: string, entityType: Types.WsapiImportEntityType, sourceTable: string, keySourceField: string, keyTargetField: string, enabled: boolean, fieldMappings: Array<{ __typename?: 'FieldMappingData', sourceField: string, targetField: string, sanitize: boolean, kind: Types.FieldMappingKind }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type EnableWsapiImportMutationVariables = Types.Exact<{
  input: Types.EnableWsapiImportInput;
}>;


export type EnableWsapiImportMutation = { __typename?: 'Mutation', enableWsapiImport: { __typename?: 'WsapiImportPayload', wsapiImport?: { __typename?: 'WsapiImportStateData', wsapiImportId: string, integrationId: string, tenantId: string, enabled: boolean, runNow: boolean, scheduleDayOfWeek?: number | null, scheduleTimeOfDay?: string | null, created: Types.TDateISO, createdBy: string, updated: Types.TDateISO, updatedBy: string, entityMappings: Array<{ __typename?: 'EntityMappingData', entityMappingId: string, entityType: Types.WsapiImportEntityType, sourceTable: string, keySourceField: string, keyTargetField: string, enabled: boolean, fieldMappings: Array<{ __typename?: 'FieldMappingData', sourceField: string, targetField: string, sanitize: boolean, kind: Types.FieldMappingKind }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DisableWsapiImportMutationVariables = Types.Exact<{
  input: Types.DisableWsapiImportInput;
}>;


export type DisableWsapiImportMutation = { __typename?: 'Mutation', disableWsapiImport: { __typename?: 'WsapiImportPayload', wsapiImport?: { __typename?: 'WsapiImportStateData', wsapiImportId: string, integrationId: string, tenantId: string, enabled: boolean, runNow: boolean, scheduleDayOfWeek?: number | null, scheduleTimeOfDay?: string | null, created: Types.TDateISO, createdBy: string, updated: Types.TDateISO, updatedBy: string, entityMappings: Array<{ __typename?: 'EntityMappingData', entityMappingId: string, entityType: Types.WsapiImportEntityType, sourceTable: string, keySourceField: string, keyTargetField: string, enabled: boolean, fieldMappings: Array<{ __typename?: 'FieldMappingData', sourceField: string, targetField: string, sanitize: boolean, kind: Types.FieldMappingKind }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ReassignWsapiImportIntegrationMutationVariables = Types.Exact<{
  input: Types.ReassignWsapiImportIntegrationInput;
}>;


export type ReassignWsapiImportIntegrationMutation = { __typename?: 'Mutation', reassignWsapiImportIntegration: { __typename?: 'WsapiImportPayload', wsapiImport?: { __typename?: 'WsapiImportStateData', wsapiImportId: string, integrationId: string, tenantId: string, enabled: boolean, runNow: boolean, scheduleDayOfWeek?: number | null, scheduleTimeOfDay?: string | null, created: Types.TDateISO, createdBy: string, updated: Types.TDateISO, updatedBy: string, entityMappings: Array<{ __typename?: 'EntityMappingData', entityMappingId: string, entityType: Types.WsapiImportEntityType, sourceTable: string, keySourceField: string, keyTargetField: string, enabled: boolean, fieldMappings: Array<{ __typename?: 'FieldMappingData', sourceField: string, targetField: string, sanitize: boolean, kind: Types.FieldMappingKind }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateWsapiImportEntityMappingMutationVariables = Types.Exact<{
  input: Types.UpdateWsapiImportEntityMappingInput;
}>;


export type UpdateWsapiImportEntityMappingMutation = { __typename?: 'Mutation', updateWsapiImportEntityMapping: { __typename?: 'WsapiImportPayload', wsapiImport?: { __typename?: 'WsapiImportStateData', wsapiImportId: string, integrationId: string, tenantId: string, enabled: boolean, runNow: boolean, scheduleDayOfWeek?: number | null, scheduleTimeOfDay?: string | null, created: Types.TDateISO, createdBy: string, updated: Types.TDateISO, updatedBy: string, entityMappings: Array<{ __typename?: 'EntityMappingData', entityMappingId: string, entityType: Types.WsapiImportEntityType, sourceTable: string, keySourceField: string, keyTargetField: string, enabled: boolean, fieldMappings: Array<{ __typename?: 'FieldMappingData', sourceField: string, targetField: string, sanitize: boolean, kind: Types.FieldMappingKind }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveWsapiImportEntityMappingMutationVariables = Types.Exact<{
  input: Types.RemoveWsapiImportEntityMappingInput;
}>;


export type RemoveWsapiImportEntityMappingMutation = { __typename?: 'Mutation', removeWsapiImportEntityMapping: { __typename?: 'WsapiImportPayload', wsapiImport?: { __typename?: 'WsapiImportStateData', wsapiImportId: string, integrationId: string, tenantId: string, enabled: boolean, runNow: boolean, scheduleDayOfWeek?: number | null, scheduleTimeOfDay?: string | null, created: Types.TDateISO, createdBy: string, updated: Types.TDateISO, updatedBy: string, entityMappings: Array<{ __typename?: 'EntityMappingData', entityMappingId: string, entityType: Types.WsapiImportEntityType, sourceTable: string, keySourceField: string, keyTargetField: string, enabled: boolean, fieldMappings: Array<{ __typename?: 'FieldMappingData', sourceField: string, targetField: string, sanitize: boolean, kind: Types.FieldMappingKind }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateWsapiImportDocument = new TypedDocumentString(`
    mutation CreateWsapiImport($input: CreateWsapiImportInput!) {
  createWsapiImport(input: $input) {
    wsapiImport {
      ...WsapiImportDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment WsapiImportDetails on WsapiImportStateData {
  wsapiImportId
  integrationId
  tenantId
  enabled
  runNow
  scheduleDayOfWeek
  scheduleTimeOfDay
  created
  createdBy
  updated
  updatedBy
  entityMappings {
    entityMappingId
    entityType
    sourceTable
    keySourceField
    keyTargetField
    enabled
    fieldMappings {
      sourceField
      targetField
      sanitize
      kind
    }
  }
}`);
export const AddWsapiImportEntityMappingDocument = new TypedDocumentString(`
    mutation AddWsapiImportEntityMapping($input: AddWsapiImportEntityMappingInput!) {
  addWsapiImportEntityMapping(input: $input) {
    wsapiImport {
      ...WsapiImportDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment WsapiImportDetails on WsapiImportStateData {
  wsapiImportId
  integrationId
  tenantId
  enabled
  runNow
  scheduleDayOfWeek
  scheduleTimeOfDay
  created
  createdBy
  updated
  updatedBy
  entityMappings {
    entityMappingId
    entityType
    sourceTable
    keySourceField
    keyTargetField
    enabled
    fieldMappings {
      sourceField
      targetField
      sanitize
      kind
    }
  }
}`);
export const SetWsapiImportRunNowDocument = new TypedDocumentString(`
    mutation SetWsapiImportRunNow($input: SetWsapiImportRunNowInput!) {
  setWsapiImportRunNow(input: $input) {
    wsapiImport {
      ...WsapiImportDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment WsapiImportDetails on WsapiImportStateData {
  wsapiImportId
  integrationId
  tenantId
  enabled
  runNow
  scheduleDayOfWeek
  scheduleTimeOfDay
  created
  createdBy
  updated
  updatedBy
  entityMappings {
    entityMappingId
    entityType
    sourceTable
    keySourceField
    keyTargetField
    enabled
    fieldMappings {
      sourceField
      targetField
      sanitize
      kind
    }
  }
}`);
export const UpdateWsapiImportScheduleDocument = new TypedDocumentString(`
    mutation UpdateWsapiImportSchedule($input: UpdateWsapiImportScheduleInput!) {
  updateWsapiImportSchedule(input: $input) {
    wsapiImport {
      ...WsapiImportDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment WsapiImportDetails on WsapiImportStateData {
  wsapiImportId
  integrationId
  tenantId
  enabled
  runNow
  scheduleDayOfWeek
  scheduleTimeOfDay
  created
  createdBy
  updated
  updatedBy
  entityMappings {
    entityMappingId
    entityType
    sourceTable
    keySourceField
    keyTargetField
    enabled
    fieldMappings {
      sourceField
      targetField
      sanitize
      kind
    }
  }
}`);
export const EnableWsapiImportDocument = new TypedDocumentString(`
    mutation EnableWsapiImport($input: EnableWsapiImportInput!) {
  enableWsapiImport(input: $input) {
    wsapiImport {
      ...WsapiImportDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment WsapiImportDetails on WsapiImportStateData {
  wsapiImportId
  integrationId
  tenantId
  enabled
  runNow
  scheduleDayOfWeek
  scheduleTimeOfDay
  created
  createdBy
  updated
  updatedBy
  entityMappings {
    entityMappingId
    entityType
    sourceTable
    keySourceField
    keyTargetField
    enabled
    fieldMappings {
      sourceField
      targetField
      sanitize
      kind
    }
  }
}`);
export const DisableWsapiImportDocument = new TypedDocumentString(`
    mutation DisableWsapiImport($input: DisableWsapiImportInput!) {
  disableWsapiImport(input: $input) {
    wsapiImport {
      ...WsapiImportDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment WsapiImportDetails on WsapiImportStateData {
  wsapiImportId
  integrationId
  tenantId
  enabled
  runNow
  scheduleDayOfWeek
  scheduleTimeOfDay
  created
  createdBy
  updated
  updatedBy
  entityMappings {
    entityMappingId
    entityType
    sourceTable
    keySourceField
    keyTargetField
    enabled
    fieldMappings {
      sourceField
      targetField
      sanitize
      kind
    }
  }
}`);
export const ReassignWsapiImportIntegrationDocument = new TypedDocumentString(`
    mutation ReassignWsapiImportIntegration($input: ReassignWsapiImportIntegrationInput!) {
  reassignWsapiImportIntegration(input: $input) {
    wsapiImport {
      ...WsapiImportDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment WsapiImportDetails on WsapiImportStateData {
  wsapiImportId
  integrationId
  tenantId
  enabled
  runNow
  scheduleDayOfWeek
  scheduleTimeOfDay
  created
  createdBy
  updated
  updatedBy
  entityMappings {
    entityMappingId
    entityType
    sourceTable
    keySourceField
    keyTargetField
    enabled
    fieldMappings {
      sourceField
      targetField
      sanitize
      kind
    }
  }
}`);
export const UpdateWsapiImportEntityMappingDocument = new TypedDocumentString(`
    mutation UpdateWsapiImportEntityMapping($input: UpdateWsapiImportEntityMappingInput!) {
  updateWsapiImportEntityMapping(input: $input) {
    wsapiImport {
      ...WsapiImportDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment WsapiImportDetails on WsapiImportStateData {
  wsapiImportId
  integrationId
  tenantId
  enabled
  runNow
  scheduleDayOfWeek
  scheduleTimeOfDay
  created
  createdBy
  updated
  updatedBy
  entityMappings {
    entityMappingId
    entityType
    sourceTable
    keySourceField
    keyTargetField
    enabled
    fieldMappings {
      sourceField
      targetField
      sanitize
      kind
    }
  }
}`);
export const RemoveWsapiImportEntityMappingDocument = new TypedDocumentString(`
    mutation RemoveWsapiImportEntityMapping($input: RemoveWsapiImportEntityMappingInput!) {
  removeWsapiImportEntityMapping(input: $input) {
    wsapiImport {
      ...WsapiImportDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment WsapiImportDetails on WsapiImportStateData {
  wsapiImportId
  integrationId
  tenantId
  enabled
  runNow
  scheduleDayOfWeek
  scheduleTimeOfDay
  created
  createdBy
  updated
  updatedBy
  entityMappings {
    entityMappingId
    entityType
    sourceTable
    keySourceField
    keyTargetField
    enabled
    fieldMappings {
      sourceField
      targetField
      sanitize
      kind
    }
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateWsapiImport: build.mutation<CreateWsapiImportMutation, CreateWsapiImportMutationVariables>({
      query: (variables) => ({ document: CreateWsapiImportDocument, variables })
    }),
    AddWsapiImportEntityMapping: build.mutation<AddWsapiImportEntityMappingMutation, AddWsapiImportEntityMappingMutationVariables>({
      query: (variables) => ({ document: AddWsapiImportEntityMappingDocument, variables })
    }),
    SetWsapiImportRunNow: build.mutation<SetWsapiImportRunNowMutation, SetWsapiImportRunNowMutationVariables>({
      query: (variables) => ({ document: SetWsapiImportRunNowDocument, variables })
    }),
    UpdateWsapiImportSchedule: build.mutation<UpdateWsapiImportScheduleMutation, UpdateWsapiImportScheduleMutationVariables>({
      query: (variables) => ({ document: UpdateWsapiImportScheduleDocument, variables })
    }),
    EnableWsapiImport: build.mutation<EnableWsapiImportMutation, EnableWsapiImportMutationVariables>({
      query: (variables) => ({ document: EnableWsapiImportDocument, variables })
    }),
    DisableWsapiImport: build.mutation<DisableWsapiImportMutation, DisableWsapiImportMutationVariables>({
      query: (variables) => ({ document: DisableWsapiImportDocument, variables })
    }),
    ReassignWsapiImportIntegration: build.mutation<ReassignWsapiImportIntegrationMutation, ReassignWsapiImportIntegrationMutationVariables>({
      query: (variables) => ({ document: ReassignWsapiImportIntegrationDocument, variables })
    }),
    UpdateWsapiImportEntityMapping: build.mutation<UpdateWsapiImportEntityMappingMutation, UpdateWsapiImportEntityMappingMutationVariables>({
      query: (variables) => ({ document: UpdateWsapiImportEntityMappingDocument, variables })
    }),
    RemoveWsapiImportEntityMapping: build.mutation<RemoveWsapiImportEntityMappingMutation, RemoveWsapiImportEntityMappingMutationVariables>({
      query: (variables) => ({ document: RemoveWsapiImportEntityMappingDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateWsapiImportMutation, useAddWsapiImportEntityMappingMutation, useSetWsapiImportRunNowMutation, useUpdateWsapiImportScheduleMutation, useEnableWsapiImportMutation, useDisableWsapiImportMutation, useReassignWsapiImportIntegrationMutation, useUpdateWsapiImportEntityMappingMutation, useRemoveWsapiImportEntityMappingMutation } = injectedRtkApi;
